import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-side-nav-content',
  templateUrl: './side-nav-content.component.html',
  styleUrls: ['./side-nav-content.component.css']
})
export class SideNavContentComponent implements OnInit {

  constructor(public translate : TranslateService) { }

  ngOnInit(): void {


  }
  get lang() {
    return this.translate.currentLang === 'en' ? 'en' : 'ar';
  }

}
